// Shared class constants for data tables (Smartlead look: white rounded card,
// light grey header with small grey labels, hairline row dividers, no zebra
// striping, subtle hover). Constants rather than a component so hand-written
// <table>s and any TanStack/virtualized table can share one look.

/**
 * Outer card wrapping the <table>. Deliberately carries NO overflow class:
 * callers add `overflow-auto` / `overflow-x-auto` themselves (any non-visible
 * overflow value already clips the rounded corners). Baking `overflow-hidden`
 * in here silently beat a caller's `overflow-auto` (Tailwind emits it later)
 * and removed the pipeline table's scrollbars.
 */
export const TABLE_SHELL = "rounded-xl border border-border bg-surface";

/** <thead> or its <tr>. */
export const THEAD_ROW = "bg-surface-muted text-left text-xs font-medium text-muted-foreground";

/** Each <th>. */
export const TH = "px-4 py-3 font-medium whitespace-nowrap";

/** Each body <tr>. */
export const TBODY_ROW = "border-t border-border hover:bg-surface-muted/60 transition-colors";

/** Each body <td>. */
export const TD = "px-4 py-3 align-middle";

/** Filled search input (grey fill, no visible border until focus). */
export const FILLED_INPUT =
  "bg-surface-muted border border-transparent rounded-lg text-sm text-foreground placeholder-muted-foreground focus:outline-none focus:bg-surface focus:border-primary transition-colors";

/** Standard bordered form control (inputs, selects, textareas). */
export const FORM_CONTROL =
  "bg-surface border border-border rounded-lg text-sm text-foreground placeholder-muted-foreground focus:outline-none focus:border-primary focus:ring-1 focus:ring-ring transition-colors disabled:opacity-50";
